import { TranslateService } from '@ngx-translate/core';
import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MyapiService } from '../../../app/services/myapi.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons';
import { MatDialog } from '@angular/material/dialog';
import { UserSignupComponent } from '../user-signup/user-signup.component';
import { ForgetPasswordComponent } from '../forget-password/forget-password.component';
import { FacebookLoginProvider, GoogleLoginProvider, SocialAuthService, SocialUser } from 'angularx-social-login';
import { Store } from '@ngrx/store';
import { loadAuthUser, loadAuthUserFailure, loadAuthUserSuccess } from '@src/app/store/user/user.actions';
import { AuthUser } from '@src/app/models/user/user';
import { selectUserLoader } from '@src/app/store/selectors';
import { Subscription } from 'rxjs/internal/Subscription';
import { AuthService } from '@src/app/services/user-managment/authentication/authentication.service';
import {LOGIN_STATUS} from '../../constant/statuses'
import Swal from 'sweetalert2';



export interface userdata {
  AccessToken: string,
  Comment: number,
  Message: string,
  applicationUser: {
    AccessFailedCount: number,
    AccessToken: string,
    Email: string,
    EmailConfirmed: boolean,
    Id: string,
    LockoutEnabled: boolean,
    LockoutEndDateUtc: any,
    Logins: [],
    PhoneNumber: string,
    PhoneNumberConfirmed: false,
    User_Name: string,
    FirstName: string,
    LastName: string
  }
}

// const LoginWithTwitter = require('login-with-twitter')

// const tw = new LoginWithTwitter({
//   consumerKey: 'TD3a2T5PUYt6JUzqwWwvxeMaH',
//   consumerSecret: '8dVlmCWquV6fUqK4ovivPdj3pRPUcmWj9Ps04kAFo9seub29V2',
//   callbackUrl: 'https://example.com/twitter/callback'
// })

@Component({
  selector: 'app-user-login',
  templateUrl: './user-login.component.html',
  styleUrls: ['./user-login.component.scss']
})
export class UserLoginComponent implements OnInit, OnDestroy {
  private subscription: Subscription = new Subscription();
  public getScreenWidth: any;
  preloader: boolean = true;
  loginform: FormGroup;
  faFacebook = faFacebook;
  faTwitter = faTwitter;

  userLoader$ = this.store.select(selectUserLoader);
  userLoader: boolean = false;
  showPassword = false;
  socialUser!: SocialUser;
  isLoggedin?: boolean = undefined;
    trigger = false;
    error :boolean = false
    hidePassword = true; 




  constructor(
    private myapi: MyapiService,
    private _snackBar: MatSnackBar,
    private Router: Router,
    public translate: TranslateService,
    public dialog: MatDialog,
    public authService: AuthService,
    private readonly store: Store) { }

ngOnInit(): void {
    this.authService.initLoginForm()
    this.subscription.add(this.authService.notify.subscribe({
      next: (status) => {
        if(status === LOGIN_STATUS.success){          
            this.dialog.closeAll();
            this.Router.navigate(['/']);
        } else if (status === LOGIN_STATUS.faild ) {
          Swal.fire({
            icon: 'error',
            title: this.translate.currentLang === 'en' ? 'Check Your Email' : 'تحقق من حسابك',
            text: 'Please try again',
          });
        }else if(status === LOGIN_STATUS.faild || status === LOGIN_STATUS.success){
          this.trigger = false
          Swal.fire({
            icon: 'success',
            title:
              this.translate.currentLang === 'en'
                ? 'Check Your Email'
                : 'تحقق من حسابك',
          })
          
        }
      }
    }))
    
  }

    onSubmit(){
    this.error = false
    if (!this.authService.loginForm.valid) {
      this.error = true
    }else{
      this.authService.loginSubmit()
    }
  }

   getLoginFormControl(controlName : string){
    return this.authService.loginForm.controls[controlName]
  }

  /**
   * Retrieves the email error message from the AuthService.
   * @returns The email error message.
   */
  get getEmailErrorMessage(){
    return this.authService.getEmailErrorMessage
  }
  
  /**
   * Retrieves the password error message from the AuthService.
   * @returns The password error message.
   */
  get getPasswordErrorMessage(){
    return this.authService.getPasswordErrorMessage
  }

  get lang() {
    return this.translate.currentLang === 'en' ? 'en' : 'ar';
  }

  get isLoading() {
    return this.authService.isLoading;
  }

  get loginForm(){
    return this.authService.loginForm
  }


  openSnackBar(message: string, action: string, Staus: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
      panelClass: [Staus]
    });
  }
  toHomepage() {
    this.Router.navigate(['/']);
  }
  toSignUp() {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(UserSignupComponent, { panelClass: 'custom-dialog-container' });
  }
  toSignUpMob() {
    this.dialog.closeAll();
    this.Router.navigate(['/signup']);
  }

  toForgetPassword() {
    this.dialog.closeAll();
    const dialogRef = this.dialog.open(ForgetPasswordComponent);
    // this.Router.navigate(['/forgetPassword']);
  }
  closeDialog() {
    this.dialog.closeAll()
  }
  
  ngOnDestroy(): void {
    this.subscription.unsubscribe()
  }

  toggleShowPassword() {
    this.showPassword = !this.showPassword;
  }

  @HostListener('window:resize', ['$event'])
  onWindowResize() {
    this.getScreenWidth = window.innerWidth;
  }
}